import StickyHeader from "./StickyHeader";
import throttle from "../utils/throttle";
const stickyNavSelector = ".js-sticky-nav";
const stickyNavStuckClass = "is-stuck";
const stickyNavs = document.querySelectorAll(stickyNavSelector);
/**
 * Set top value to sticky navigation dynamically if sticky header is in affixed state.
 */
function setOffsetToStickyNav() {
    if (!stickyNavs.length)
        return;
    document.addEventListener("affixed.restaumatic.sticky-header", () => {
        if (!StickyHeader.utils.isHeaderSticky())
            return;
        stickyNavs.forEach((nav) => {
            nav.style.top = `${StickyHeader.utils.getStickyHeaderHeight()}px`;
            document.documentElement.style.setProperty("--sticky-header-height", `${StickyHeader.utils.getStickyHeaderHeight()}px`);
        });
    });
}
/**
 * Check if a sticky nav is currently in stuck state (pinned at top below the header).
 */
function isNavStuck(nav) {
    const rect = nav.getBoundingClientRect();
    const headerHeight = StickyHeader.utils.getStickyHeaderHeight();
    return rect.top >= headerHeight - 1 && rect.top <= headerHeight + 1;
}
/**
 * Toggle is-stuck class on each sticky nav when it is pinned at the top.
 */
function observeNavStuckState() {
    if (!stickyNavs.length)
        return;
    window.addEventListener("scroll", throttle(() => {
        stickyNavs.forEach((nav) => {
            nav.classList.toggle(stickyNavStuckClass, isNavStuck(nav));
        });
    }, 200));
}
/**
 * Sticky Navigation.
 */
export default {
    init: () => {
        setOffsetToStickyNav();
        observeNavStuckState();
    },
};
